import { Select, SelectField, type SelectFieldProps, type SelectProps } from '@nvision/ui';

import { type PackageTypeFilters, usePackageTypes } from '../../hooks';
import type { CarrierCode } from '../../models';

export interface PackageTypeFieldProps extends Omit<SelectProps<CarrierCode>, 'options'> {
  defaultFilters?: Partial<PackageTypeFilters>;
  label?: string;
  errorMessage?: SelectFieldProps<CarrierCode>['errorMessage'];
  isInvalid?: boolean;
}

export const PackageTypeField: React.FC<PackageTypeFieldProps> = ({ defaultFilters, label, ...otherFieldProps }) => {
  const { data, isLoading, updateFilters } = usePackageTypes(defaultFilters);

  if (label) {
    return (
      <SelectField
        {...otherFieldProps}
        label={label}
        placeholder="Select"
        options={data?.list ?? []}
        onInputChange={(search) => updateFilters({ search: { codeDesc: search } })}
        isLoading={isLoading}
      />
    );
  }

  return (
    <Select
      {...otherFieldProps}
      placeholder="Select"
      options={data?.list ?? []}
      onInputChange={(search) => updateFilters({ search: { codeDesc: search } })}
      isLoading={isLoading}
    />
  );
};
